import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useAdminCockpit = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [plans, setPlans] = useState([])

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await RequestService.getAdminCockpitData()
      setData(data || [])
      setPlans(data.plans || [])
    } catch (e) {
      console.log('useAdminCockpit', e)
    }

    setLoading(false)
  })

  useEffect(() => {
    fetchData()
  }, [])

  return {
    loading,
    data,
    plans,
  }
}

export default useAdminCockpit
